import React, { Component } from "react";
import {
    Icon,
    Row,
    Col,
    Card,
    Modal,
    Select,
    Radio,
    Button,
    Spin,
    DatePicker,
    Checkbox,
    Input,
    Switch,
    message,
} from "antd";
import axios from "axios";
import moment from "moment";
import F from "../../Functions";
import { LEAD_DETAILS_SETTINGS, SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN } from "../../utils/Constants";

const { TextArea } = Input;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
    state = {
        loading: false,
        showLeadDetailsPopup: false,
        showLeadCardAndAppointments: false
    };

    updateAgency = async (name, value) => {
        const { agency } = this.props;
        const isLeadToggle = name === "is_lead";
        const isOppToggle = name === "is_opportunity";

        if (isLeadToggle && !value) {
            this.setState({
                showLeadDetailsPopup: true,
                showLeadCardAndAppointments:
                    this.props.agency.show_lead_card_appointment_details
            });
        }

        if (isLeadToggle && value == 1) {
            this.props.updateAgency(
                "show_lead_card_appointment_details",
                value
            );
        }

        let payload = { [name]: value };

        if (isLeadToggle || isOppToggle) {
            const new_is_lead = isLeadToggle ? value : agency.is_lead;
            const new_is_opportunity = isOppToggle ? value : agency.is_opportunity;

            // const vonboard = new_is_lead === 1 || new_is_opportunity === 1 || show ? 1 : 0;

            const vonboard = (
                new_is_lead === 1 ||
                new_is_opportunity === 1 ||
                agency.show_lead_card_appointment_details === 1
            ) ? 1 : 0;

            payload = {
                is_lead: new_is_lead,
                is_opportunity: new_is_opportunity,
                vonboard,
                ...(new_is_lead && { show_lead_card_appointment_details: 1 })
            };
        }

        this.setState({ loading: true });;

        try {
            await axios.put("/api/agencies/" + agency.id, payload);
            this.props.updateAgency(name, value);

            message.success(F.translate(`Agency has been updated successfully.`));
            if (name == "active") {
                this.props.loadAllAgencies();
                this.props.hideModal();
            }
        } catch (error) {
            console.error(error);
            message.error(
                F.translate(
                    error.response.message ||
                    error.response.data.message ||
                    SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN
                )
            );
        } finally {
            this.setState({ loading: false });
        }
    };


    handleLeadPopUpCheckBoxSave = async (isChecked) => {
        const { agency, updateAgency } = this.props;
        const is_lead = this.props.agency.is_lead;
        const is_opportunity = this.props.agency.is_opportunity;
        // const vonboard = is_lead && is_opportunity ;
        const vonboard = (
            is_lead === 1 ||
            is_opportunity === 1 ||
            isChecked
        ) ? 1 : 0;
        const review = this.props.agency.review;
        const { showLeadCardAndAppointments } = this.state;

        this.setState({ loading: true });

        try {
            await axios.put(`/api/agencies/${agency.id}`, {
                show_lead_card_appointment_details: isChecked ? 1 : 0,
                is_lead: is_lead,
                is_opportunity: is_opportunity,
                vonboard: vonboard,
                review: review
            });

            updateAgency(
                "show_lead_card_appointment_details",
                isChecked ? 1 : 0
            );

            message.success("Lead preference updated successfully!");
        } catch (err) {
            console.error(err);
            message.error("Something went wrong!");
        } finally {
            this.setState({
                loading: false,
                showLeadDetailsPopup: false,
            });
        }
    };




    render() {
        const { loading } = this.state;
        const { agency } = this.props;

        const updateAgency = this.updateAgency;

        return (
            <Modal
                title="Edit Agency"
                visible={this.props.showModal}
                onCancel={this.props.hideModal}
                footer={null}
            >
                <Spin indicator={antIcon} spinning={loading}>
                    <div className="inputField">
                        <Switch
                            checked={agency.active ? true : false}
                            onChange={(checked) => updateAgency("active", checked ? 1 : 0)}
                        />
                        <span style={{ marginLeft: 10 }}>Active</span>
                    </div>
                    {/* <div className="inputField">
                        <Switch checked={agency.vonboard ? true : false}
                            onChange={(checked) => updateAgency('vonboard', (checked) ? 1 : 0)} />
                        <span style={{ marginLeft: 10 }}>Follow-Up Specialist</span>
                    </div> */}
                    <div className="inputField">
                        <Switch
                            checked={agency.is_lead ? true : false}
                            onChange={(checked) => updateAgency("is_lead", checked ? 1 : 0)}
                        />
                        <span style={{ marginLeft: 10 }}>Lead</span>
                        {
                            agency.is_lead == false && (
                                <div style={{ marginLeft: 5, marginTop: 10 }}>
                                    <Checkbox
                                        checked={agency.show_lead_card_appointment_details === 1}
                                        onChange={(e) => {
                                            this.setState({
                                                showLeadCardAndAppointments:
                                                    e.target.checked
                                            })
                                            this.handleLeadPopUpCheckBoxSave(e.target.checked);
                                        }
                                        }
                                    >
                                        Show Lead B Files and appointment details on dashboard
                                    </Checkbox>
                                </div>
                            )
                        }

                    </div>
                    <div className="inputField">
                        <Switch
                            checked={agency.is_opportunity ? true : false}
                            onChange={(checked) =>
                                updateAgency("is_opportunity", checked ? 1 : 0)
                            }
                        />
                        <span style={{ marginLeft: 10 }}>Opportunity</span>
                    </div>
                    <div className="inputField">
                        <Switch
                            checked={agency.review ? true : false}
                            onChange={(checked) => updateAgency("review", checked ? 1 : 0)}
                        />
                        <span style={{ marginLeft: 10 }}>Review</span>
                    </div>
                    <div className="inputField">
                        <Switch
                            checked={agency.test ? true : false}
                            onChange={(checked) => updateAgency("test", checked ? 1 : 0)}
                        />
                        <span style={{ marginLeft: 10 }}>Test Agency</span>
                    </div>
                    {/* <div className="inputField">
                        <Switch checked={agency.calculator_only ? true : false} onChange={(checked) => updateAgency('calculator_only', (checked) ? 1 : 0 )} />
                        <span style={{marginLeft:10}}>Calculator Only</span>
                    </div> */}

                </Spin>
            </Modal>
        );
    }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/edit-agency-modal.js